import { createGlobalStyle } from 'styled-components';

import 'react-toastify/dist/ReactToastify.css';

import AxiformaMedium from 'assets/fonts/Axiforma-Medium.ttf';
import AxiformaBold from 'assets/fonts/Axiforma-Bold.ttf';
import AxiformaLight from 'assets/fonts/Axiforma-Light.ttf';

export default createGlobalStyle`
/* Reset */
html,body,div,span,applet,object,iframe,h1,h2,h3,h4,h5,h6,p,blockquote,pre,a,abbr,acronym,address,big,cite,code,del,dfn,em,img,ins,kbd,q,s,samp,small,strike,strong,sub,sup,tt,var,b,u,i,center,dl,dt,dd,ol,ul,li,fieldset,form,label,legend,table,caption,tbody,tfoot,thead,tr,th,td,article,aside,canvas,details,embed,figure,figcaption,footer,header,hgroup,menu,nav,output,ruby,section,summary,time,mark,audio,video{border:0;font-size:100%;font:inherit;vertical-align:baseline;margin:0;padding:0}article,aside,details,figcaption,figure,footer,header,hgroup,menu,nav,section{display:block}body{line-height:1}ol,ul{list-style:none}blockquote,q{quotes:none}blockquote:before,blockquote:after,q:before,q:after{content:none}table{border-collapse:collapse;border-spacing:0}

@font-face {
    font-family: Axiforma;
    src: local(Axiforma),
    url(${AxiformaLight});
    font-weight: 300;
}

@font-face {
    font-family: Axiforma;
    src: local(Axiforma),
    url(${AxiformaMedium});
    font-weight: normal;
}

@font-face {
    font-family: Axiforma;
    src: local(Axiforma),
    url(${AxiformaBold});
    font-weight: bold;
}


:root{
  --blue12: #1278D7;
  --blueb3: #B3E5F3;
  --blue31: #31409A;
  --blueE5: #E5EAFDA6;
  --blue2f: #2f8fdc;
  --blue00: #0078D7;
  --blue02: #021793;
  --bluef0: #F0F8FF;
  --blue3d: #3D91FF;
  --graycd: #CDCDCD;
  --gray7a: #7A7A7A;
  --gray25: #252731;
  --grayad: #ADACAC;
  --redad: #D10000;
  }

  * {
    font-family: Axiforma !important;

    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  .element---hide{
    display: none;
  }

  html {
    @media (max-width: 1080px) {
      font-size: 93.75%;
    }

    @media (max-width: 720px) {
      font-size: 85%;
    }

    @media (max-width: 360px) {
      font-size: 70%;
    }

    @media (max-width: 290px) {
      font-size: 62%;
    }
  }

  @keyframes entering{
    from{
      opacity: 0;
    }
    to{
      opacity: 1;
    }
  }

  @keyframes exiting{
    from{
      opacity: 1;
    }
    to{
      opacity: 0;
    }
  }
`;
